import { createFileRoute, redirect } from '@tanstack/react-router';
import Introduction from '../components/ScrollyPage/Introduction';
import { FEATURES } from '../constants';

export const Route = createFileRoute('/')({
    beforeLoad: () => {
        /**
         * At the time of writing this the landing page is very heavily Huddinge oriented. There are other deployments
         * (Järfälla and Skaraborg) that should keep the behaviour of show the tool right away.
         */
        if (FEATURES.SKIP_LANDING_PAGE) {
            throw redirect({ to: '/tool' });
        }
    },
    component: Index,
});

function Index() {
    return <Introduction />;
}
